export const footerLinks = [
  {
    text: "Contact Us",
    href: "https://www.moneysupermarket.com/c/customer-care/",
  },
  {
    text: "Investor Relations",
    href: "http://corporate.moneysupermarket.com/",
  },
  {
    text: "Privacy",
    href: "https://www.moneysupermarket.com/legal/privacy-policy/",
  },
  {
    text: "Careers",
    href: "http://www.moneysupermarketjobs.com/",
  },
  {
    text: "News",
    href: "https://www.moneysupermarket.com/press-releases/",
  },
  {
    text: "Terms & Conditions",
    href: "https://www.moneysupermarket.com/legal/terms/",
  },
  {
    text: "Security",
    href: "https://www.moneysupermarket.com/legal/security/",
  },
  {
    text: "Cookie Policy",
    href: "https://www.moneysupermarket.com/legal/cookie-policy/",
  },
];
